import { createContext } from 'react';

export const FormContext = createContext({
  resourceName: '',
  readOnly: true
});
